// BonusHistoryScreen.tsx
import React from "react";
import { MdHistory, MdAddCircle, MdRemoveCircle } from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";
import { useBonusHistoryScreen } from "./useBonusHistoryScreen";
import { MobileHeader } from "../../common/components/mobileHeader/MobileHeader";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import Loader from "../../common/components/loader/Loader";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import styles from "./BonusHistoryScreen.module.scss";
import BonusStatsItem from "./components/bonusStatsItem/BonusStatsItem";
import BonusTransactionItem from "./components/bonusTransactionItem/BonusTransactionItem";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function BonusHistoryScreen() {
  const { theme } = useTheme();
  const { transactions, stats, loading, error, isOnline } = useBonusHistoryScreen();

  const hasTransactions = transactions && transactions.length > 0;

  if (loading && !hasTransactions) {
    return (
      <div className={styles.container} style={{ backgroundColor: theme.background }}>
        <PageMeta />
        <div className={styles.mobileOnly}>
          <MobileHeader title="История бонусов" />
        </div>
        <div className={styles.desktopOnly}>
          <ProductHeader
            title="История бонусов"
            isFavorite={false}
            showFavorite={false}
            textColor={theme.text}
            borderColor={theme.border}
          />
        </div>
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container} style={{ backgroundColor: theme.background }}>
      <PageMeta />
      <div className={styles.mobileOnly}>
        <MobileHeader title="История бонусов" />
      </div>
      <div className={styles.desktopOnly}>
        <ProductHeader
          title="История бонусов"
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
        />
      </div>

      <div className={styles.content}>
        {!isOnline && (
          <div className={styles.offlineMessage} style={{ backgroundColor: theme.danger }}>
            <span className={styles.offlineMessageText}>Нет подключения к интернету</span>
          </div>
        )}

        {error && isOnline && (
          <div className={styles.errorMessage} style={{ borderColor: theme.danger }}>
            <span className={styles.errorMessageText} style={{ color: theme.danger }}>
              {error}
            </span>
          </div>
        )}

        {stats && (
          <div className={styles.statsContainer}>
            <BonusStatsItem icon={MdAddCircle} title="Начислено всего" value={stats.totalEarned} />
            <BonusStatsItem icon={MdRemoveCircle} title="Списано всего" value={stats.totalSpent} />
          </div>
        )}

        {hasTransactions ? (
          <div className={styles.listContainer}>
            {transactions.map((item) => (
              <BonusTransactionItem key={item?.id || Math.random()} transaction={item} />
            ))}
            {loading && (
              <div className={styles.footerLoader}>
                <Loader />
              </div>
            )}
          </div>
        ) : (
          !loading &&
          isOnline && (
            <EmptyState
              icon={MdHistory}
              title="История операций пуста"
              description="У вас пока нет бонусных операций"
            />
          )
        )}
      </div>
    </div>
  );
}